import React, { useState, useEffect, useRef } from "react";
import { PureIncrement, PureDecrement } from "pure_counter";
import { useTranslation } from "react-i18next";

function StatsSection() {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setIsVisible(true);
          observer.disconnect(); // Stop observing after it becomes visible
        }
      },
      { threshold: 0.4 } // Trigger when 30% of the section is visible
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section id="stats" className="stats section" ref={sectionRef}>
      <div className="container">
        <div className="row gy-4">
          {isVisible && (
            <>
              <div className="col-lg-3 col-md-6 d-flex flex-column align-items-center">
                <i className="bi bi-emoji-smile" />
                <div className="stats-item">
                  <PureIncrement
                    start={0}
                    end={50}
                    duration={1}
                    className="purecounter"
                  />
                  <p>{t("happyclients")}</p>
                </div>
              </div>

              <div className="col-lg-3 col-md-6 d-flex flex-column align-items-center">
                <i className="bi bi-journal-richtext" />
                <div className="stats-item">
                  <PureIncrement
                    start={0}
                    end={75}
                    duration={1}
                    className="purecounter"
                  />
                  <p>{t("projects")}</p>
                </div>
              </div>

              <div className="col-lg-3 col-md-6 d-flex flex-column align-items-center">
                <i className="bi bi-headset" />
                <div className="stats-item">
                  <PureIncrement
                    start={0}
                    end={24}
                    duration={1}
                    className="purecounter"
                  />
                  <p>{t("hos")}</p>
                </div>
              </div>

              <div className="col-lg-3 col-md-6 d-flex flex-column align-items-center">
                <i className="bi bi-people" />
                <div className="stats-item">
                  <PureIncrement
                    start={0}
                    end={20}
                    duration={1}
                    className="purecounter"
                  />
                  <p>{t("hardWorkers")}</p>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </section>
  );
}

export default StatsSection;
